import type {AppraiserRepository} from '@/domain/interfaces/AppraiserRepository';
import type {HttpClient} from '@/infrastructure/interfaces/HttpClient';
import type {AppraiserDto} from './AppraiserDto';
import {toDomain} from './AppraiserMappers';

const PATH = 'appraisers/';

export class RestAppraiserRepository implements AppraiserRepository {
  constructor(private readonly httpClient: HttpClient) {}
  getAll = async () => {
    const appraisers = await this.httpClient.get<Array<AppraiserDto>>(PATH);
    return appraisers.map((appraiser) => toDomain(appraiser));
  };
}
